import { Button } from "@mui/material";
import { CartBarBadgeItem } from "./cartBarBadgeItem";
import { useRouteNavigator } from "../../routes/useRouteNavigator";

export function CartBarBadgeButton() {
    const routeNavigator = useRouteNavigator();

    return (
        <Button
            sx={{
                backgroundColor: "transparent",
                color: "primary.contrastText",
                boxShadow: "none",
                px: "6px",
                '&:hover': {
                    boxShadow: "none",
                    backgroundColor: "rgba(0, 0, 0, 0.04)"
                }
            }}
            onClick={() => routeNavigator.goToCart()}>
            <CartBarBadgeItem />
        </Button>
    );
}